import {UnderMaintenanceComponent} from './under-maintenance.component';

export default UnderMaintenanceComponent;